import { HttpErrorResponse, type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { ApiError } from '../error/api-error';
import { LoggerService } from '../logging/logger.service';

export const errorInterceptor: HttpInterceptorFn = (request, next) => {
  const logger = inject(LoggerService);

  return next(request).pipe(
    catchError((error: unknown) => {
      if (!(error instanceof HttpErrorResponse)) {
        return throwError(() => error);
      }

      const apiError = ApiError.fromHttp(error);

      logger.debug(`${request.method} ${request.urlWithParams} failed`, {
        status: apiError.status,
      });

      return throwError(() => apiError);
    }),
  );
};
